// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger__Burger__2h2kL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 50
// module chunks = 0